// extracted by mini-css-extract-plugin
module.exports = {"addNotecardCategoryButtonContainer":"AddNotecardCategoryButton_addNotecardCategoryButtonContainer__PiT7X"};